<template>
  <div>
    <div class="bg-gray-50 mb-3 flex flex-wrap rounded-12 p-3 items-center">
      <svg role="presentation" focusable="false" tabindex="-1" class="icon opacity-50 text-gray-800 m-2 w-5 h-5"
         
        alt="search"
        svg-inline
       xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title>search</title>
  <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
</svg>
      <input
        type="text"
        name="filter"
        class="w-full border-none outline-none rounded-4 text-18 font-semibold flex-1 bg-transparent h-10 tracking-wide placeholder:text-opacity-60 placeholder:text-gray-600 placeholder:italic"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('textChange', ($event.target as HTMLInputElement).value)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  placeholder: string
  value: string
}>()

defineEmits(['textChange'])
</script>
